import { CHUNK_SIZE, Layers } from './shared'

export const CHUNK_TILE_LAYERS = 4

export const ChunkTileLayers = [Layers.TERRAIN, Layers.DECOR, Layers.OBJECT, Layers.OVERLAY]

export const ChunkTileLayerSlots = {
  [Layers.TERRAIN]: 0,
  [Layers.DECOR]: 1,
  [Layers.OBJECT]: 2,
  [Layers.OVERLAY]: 3,
}

export function getChunkTileIndex(tx, ty, layer) {
  const layerSlot = ChunkTileLayerSlots[layer]
  if (layerSlot == null) {
    throw new Error(`unknown chunk tile layer: ${layer}`)
  }
  return (ty * CHUNK_SIZE + tx) * CHUNK_TILE_LAYERS + layerSlot
}

export function getChunkTileIndexAtWorld(x, y, layer) {
  const tx = ((x % CHUNK_SIZE) + CHUNK_SIZE) % CHUNK_SIZE
  const ty = ((y % CHUNK_SIZE) + CHUNK_SIZE) % CHUNK_SIZE
  return getChunkTileIndex(tx, ty, layer)
}

export function getChunkTileWorld(chunkX, chunkY, idx) {
  const cellIdx = Math.floor(idx / CHUNK_TILE_LAYERS)
  const tx = cellIdx % CHUNK_SIZE
  const ty = Math.floor(cellIdx / CHUNK_SIZE)
  return {
    x: chunkX * CHUNK_SIZE + tx,
    y: chunkY * CHUNK_SIZE + ty,
    layer: ChunkTileLayers[idx % CHUNK_TILE_LAYERS],
  }
}

export function createChunkTiles() {
  return new Array(CHUNK_SIZE * CHUNK_SIZE * CHUNK_TILE_LAYERS).fill(0)
}

export function createChunkPalette() {
  return [null]
}
